import { Component } from 'react';
import './complex-meta-data-table.css';

class ComplexMetaDataTable extends Component {
  formatValue(value) {
    if (value === '#X') {
      value = <i class="fa fa-times class complex_meta_fail"></i>;
    } else if (value === '#V') {
      value = <i class="fa fa-check class complex_meta_success"></i>;
    }

    return value;
  }

  prepareData(data) {
    if (!data) {
      return [];
    }
    const content = [];
    const headContent = [];
    const bodyContent = [];
    const tableHeaders = [];
    const firstData = data[0];
    for (const key in firstData) {
      tableHeaders.push(key);
      headContent.push(<th className="complex_meta_data">{key}</th>);
    }

    let currentData;

    for (const index in data) {
      const rowContent = [];
      currentData = data[index];
      for (const headerIndex in tableHeaders) {
        const key = tableHeaders[headerIndex];

        if (!(typeof currentData[key] === 'undefined')) {
          const value = this.formatValue(currentData[key]);

          rowContent.push(<td className="complex_meta_data">{value}</td>);
        } else {
          rowContent.push(<td className="complex_meta_data"></td>);
        }
      }

      bodyContent.push(<tr>{rowContent}</tr>);
    }

    content.push(
      <table className="complex_meta_table">
        <thead>
          <tr>{headContent}</tr>
        </thead>
        <tbody>{bodyContent}</tbody>
      </table>
    );

    return content;
  }
  render() {
    const { data } = this.props;

    return this.prepareData(data);
  }
}

export default ComplexMetaDataTable;
